<template>
  <div class="keywordRecommendationContainer">
    <div class="keywordRecommendationHeader">
      <div class="keywordRecommendationHeaderTitle">{{$t('texts.history')}}</div>
      <div class="oldKeyWordContainer">
        <!-- <div class="oldKeyWordItem">
          <div>靴下</div>
          <el-icon><Close /></el-icon>
        </div>
         -->
      </div>
    </div>
    <div class="keywordRecommendationFooter">
      <div v-for="categorySearchItem in  categorySearchTreeListData">
        <div class="topKeywordType">{{categorySearchItem.chinese_name}}</div>
        <div
        
          class="relationHotCateListContainer"
        >
          <div   v-for="hotCateItem in  categorySearchItem.relation_hot_cate"
            @click="()=>router.push('/product/search?keyword='+hotCateItem.seKeyword)"
          >{{ hotCateItem.seKeyword }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useMainStore,  } from "~/composables/store";
import { Menu, Search, Close } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { get } from "lodash-es";
import { $t } from "~/utils/index.js";
import { categorySearchTreeListFn } from "./categoryConfig";
const store = useMainStore(); 
const router=useRouter();
const categorySearchTreeListData=computed(()=>{
  return categorySearchTreeListFn()
})
</script>

<style scoped lang="less">
.keywordRecommendationContainer {
  max-height: 600px;
  overflow: scroll;

}

.keywordRecommendationFooter{
  padding: 0 15px 15px;
}

.keywordRecommendationContainer .keywordRecommendationHeader {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
  padding: 15px 15px 10px;
 
}

.keywordRecommendationContainer .keywordRecommendationHeader .keywordRecommendationHeaderTitle {
  font-size: 14px;
  color: #c6c6c6;
  margin-right: 11px;
  padding-top: 3px;
  white-space: nowrap;
}

.keywordRecommendationContainer .keywordRecommendationHeader .oldKeyWordContainer {
  display: flex;
  flex-wrap: wrap;
  width: 528px
}

.keywordRecommendationContainer .keywordRecommendationHeader .oldKeyWordContainer .oldKeyWordItem {
  height: 26px;
  padding: 8px 9px 7px;
  background: #f5f5f5;
  border-radius: 4px;
  box-sizing: border-box;
  margin-right: 6px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  cursor: pointer
}

.keywordRecommendationContainer .keywordRecommendationHeader .oldKeyWordContainer .oldKeyWordItem div {
  color: #999;
  font-size: 12px;
  margin-right: 9px
}

.keywordRecommendationContainer .keywordRecommendationFooter .topKeywordType {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  margin-top: 15px
}

.keywordRecommendationContainer .keywordRecommendationFooter .relationHotCateListContainer {
  display: flex;
  flex-wrap: wrap
}

.keywordRecommendationContainer .keywordRecommendationFooter .relationHotCateListContainer div {
  height: 29px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 0 8px;
  line-height: 29px;
  cursor: pointer;
  font-size: 14px;
  color: #999;
  margin: 12px 0 0 12px
}

.keywordRecommendationContainer .keywordRecommendationFooter .relationHotCateListContainer div:first-child {
  margin-left: 0
}

.keywordRecommendationContainer .keywordRecommendationFooter .relationHotCateListContainer div:hover {
  background: linear-gradient(90deg,#ff7e3e,#ff5010,#fe4b0f);
  color: #fff
}

.keywordRecommendationContainer::-webkit-scrollbar {
  width: 0
}
</style>
